module.exports = __webpack_public_path__ + "54ab66cd86034b4a53f5913acb30845f.png";